export function normalizeDirectoryText(value) {
    return String(value || '').trim().toLowerCase()
}

export async function showDirectoryPageWithRecord({ firstPage, loadPage, matches, fallbackPage = 1 }) {
    const totalPages = Math.max(Number(firstPage?.totalPages) || 1, 1)
    const hasRecord = (pageData) => Array.isArray(pageData?.docs) && pageData.docs.some(matches)

    if (hasRecord(firstPage)) {
        return firstPage
    }

    for (let page = 2; page <= totalPages; page += 1) {
        const pageData = await loadPage(page)
        if (hasRecord(pageData)) {
            return pageData
        }
    }

    if (fallbackPage !== totalPages || totalPages > 1) {
        return loadPage(fallbackPage)
    }

    return firstPage
}
